// SYSTEM_ROUTE: /search
import { useState } from 'react';
import { CommandBar, CompactRow, EmptyState, Pane, PrivacyChip, Stack } from '@life-os/ui';
import { useStore } from '../app/store.js';
import { useRouter } from '../app/router.js';
import { ScreenHeader } from '../app/ScreenHeader.js';
import { searchAll } from '../lib/search.js';
import { useAsync } from '../lib/useAsync.js';

const GROUP_LABEL: Record<string, string> = {
  system: 'Systems',
  task: 'Tasks',
  capture: 'Captured',
};

export function SearchScreen() {
  const { registry, data, revision } = useStore();
  const { navigate } = useRouter();
  const [q, setQ] = useState('');
  const results = useAsync(() => searchAll(q, registry, data), [q, revision]);
  const groups = results.value ?? [];

  return (
    <>
      <ScreenHeader
        title="Search"
        subtitle={<>Find anything; answer "where is it?" Try filters: <code>privacy:strict_local</code>, <code>kind:task</code>, <code>maturity:daily</code>.</>}
      />

      <CommandBar value={q} onChange={setQ} autoFocus placeholder="Search everything…" />

      {groups.length === 0 ? (
        <EmptyState title="Nothing matches">Try another term, or open All Systems to browse.</EmptyState>
      ) : (
        groups.map((g) => (
          <Pane key={g.kind} title={GROUP_LABEL[g.kind] ?? g.kind} hint={`${g.results.length}`}>
            <Stack>
              {g.results.map((r) => (
                <CompactRow
                  key={r.id}
                  title={r.title}
                  subtitle={r.preview}
                  onClick={r.surface.startsWith('/') ? () => navigate(r.surface) : undefined}
                  meta={<PrivacyChip value={r.privacyClass} />}
                />
              ))}
            </Stack>
          </Pane>
        ))
      )}
    </>
  );
}
